import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { Box } from '@mui/material'
import { EmtIcon, EmtTypography } from 'emt-components-v2'

interface Props {
  handleAddPet: () => void
}

const AddBox: FC<Props> = ({ handleAddPet }) => {
  const { t } = useTranslation('connection')
  return (
    <>
      {/* The clickable box to open the modal */}
      <Box
        onClick={handleAddPet}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '15px',
          padding: '15px',
          border: '2px dashed #BBBABF',
          borderRadius: '16px',
          cursor: 'pointer',
          backgroundColor: '#F0F0F1',
        }}
      >
        {/* Circle with plus icon */}
        <Box
          sx={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fff',
            border: '1px solid #F9F9F9',
            boxShadow: '0px 4px 56px 0px #00000014, 0px 12px 16px 0px #00000014',
          }}
        >
          <EmtIcon className="emt-add" size="medium" color="primary" sx={{ fontSize: '17px' }} />
        </Box>

        {/* Label text */}
        <EmtTypography variant="body1" fontWeight="700">
          {t('create-your-profile-petowner.addNewPet')}
        </EmtTypography>
      </Box>
    </>
  )
}

export default AddBox
